import { connect } from 'react-redux';
import { UpdatedIndicationComponent } from './UpdatedIndication.component';

const mapStateToProps = ({ knowledge }) => ({
  previousLastUpdated: knowledge.previousLastUpdated,
});

export const UpdatedIndication = connect(mapStateToProps)(UpdatedIndicationComponent);
